import { render, staticRenderFns } from "./TheLayoutPortal.vue?vue&type=template&id=6755ff26"
import script from "./TheLayoutPortal.vue?vue&type=script&lang=ts"
export * from "./TheLayoutPortal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports